import { z } from "zod";
import { LocaleSchema } from "./user";
import { SeatingCanvasInsetSchema } from "./seating-canvas";
import { TableSchema, RoomElementSchema } from "./table";
/**
 * Public seating-plan token document — stored at `/seatingTokens/{token}` where
 * the document id *is* the secret token.
 *
 * Denormalised snapshot: the public viewer is unauthenticated and cannot read
 * `/weddings`, `/seatingPlans`, or `/guests`. Everything the read-only canvas
 * + per-table list need lives here. The couple's authenticated client
 * (re)writes this doc whenever a relevant field changes — see
 * apps/web/src/features/seating/share/operations.ts.
 */
export const SeatingShareOccupantSchema = z.object({
    seatIndex: z.number().int().nonnegative(),
    label: z.string(),
    /** Structural tag (+1, child marker) — not a meal preference. */
    sub: z.string().nullable().optional(),
    /** Localised meal / menu preference label for PDF list export. */
    meal: z.string().nullable().optional(),
});
export const SeatingSharePlanSchema = z.object({
    id: z.string(),
    name: z.string(),
    seatingCanvasInset: SeatingCanvasInsetSchema.optional(),
    seatingRoomWidthM: z.number().positive().optional(),
});
export const SeatingTokenSchema = z.object({
    /** Mirrors the document id — the secret token. */
    token: z.string(),
    weddingId: z.string(),
    seatingPlanId: z.string(),
    /** When false the public viewer shows a "link disabled" state. */
    enabled: z.boolean().default(true),
    coupleName1: z.string(),
    coupleName2: z.string().nullable().optional(),
    weddingDate: z.string().datetime().nullable().optional(),
    venue: z.string().nullable().optional(),
    locale: LocaleSchema.default("pl"),
    plan: SeatingSharePlanSchema,
    tables: z.array(TableSchema).default([]),
    roomElements: z.array(RoomElementSchema).default([]),
    /** Per-table occupant labels keyed by table id. */
    occupantsByTable: z.record(z.array(SeatingShareOccupantSchema)).default({}),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
